<td
    class=""
    [ngClass]="(columns | async)[0].class"
>
    <div class="floa-metric-name-bar-container">
        <span class="floa-metric-name">
            {{ floaMetric.metricName }}
        </span>
    </div>
</td>

<td
    [ngClass]="(columns | async)[1].class"
    class="overall-count"
>
    {{
        floaMetric.opportunityCount != null
            ? (floaMetric.opportunityCount | number: '1.0-0')
            : '-'
    }}
</td>

<td
    [ngClass]="(columns | async)[2].class"
    class="p-1"
>
    <div class="fraction-table-container">
        <fraction-bar
            class="floa-metric-bar"
            [numerator]="floaMetric.coachedOpportunities"
            [denominator]="floaMetric.uncoachedOpportunities"
            [divisor]="floaMetric.opportunityCount"
            [numeratorClass]="'green'"
            [denominatorClass]="'grey'"
            [barWidth]="barWidth"
            [numeratorLabel]="floaMetric.coachedOpportunities"
            [denominatorLabel]="floaMetric.uncoachedOpportunities"
            [showHoverTooltip]="true"
            [hoverTemplate]="fractionHoverTpl"
        >
        </fraction-bar>
    </div>
</td>

<ng-template
    #fractionHoverTpl
    let-data="data"
>
    <div class="oa-widget-tooltip custom-tooltip oatooltip">
        <div class="metric-mini-view">
            <table>
                <tr class="metric-view-divider">
                    <th>{{ i18n._7476_TOTAL_OPPORTUNITIES | translate }}</th>
                    <td>
                        {{
                            floaMetric.opportunityCount != null
                                ? (floaMetric.opportunityCount
                                  | number: '1.0-0')
                                : '-'
                        }}
                    </td>
                </tr>
                <tr class="metric-view-divider">
                    <th>
                        {{ i18n._7477_TOTAL_COACHED_OPPORTUNITIES | translate }}
                    </th>
                    <td>
                        {{
                            floaMetric.coachedOpportunities != null
                                ? (floaMetric.coachedOpportunities
                                  | number: '1.0-0')
                                : '-'
                        }}
                    </td>
                </tr>
                <tr class="metric-view-divider">
                    <th>
                        {{
                            i18n._7478_TOTAL_UNCOACHED_OPPORTUNITIES | translate
                        }}
                    </th>
                    <td>
                        {{
                            floaMetric.uncoachedOpportunities != null
                                ? (floaMetric.uncoachedOpportunities
                                  | number: '1.0-0')
                                : '-'
                        }}
                    </td>
                </tr>
            </table>
        </div>
    </div>
</ng-template>
